<template id="map-template">
  <div class="zj-homeview-root select-none">
    <MapView MapKey="HomeViewMap"></MapView>
    <div class="left-side" v-show="!isLeftSideHide">
      <div class="left-side-1">
        <div class="content-wrapper">
          <HomeViewRealtimeData></HomeViewRealtimeData>
        </div>
      </div>
      <div class="left-side-2">
        <div class="content-wrapper">
          <HomeViewDeviceList></HomeViewDeviceList>
        </div>
      </div>
      <div class="left-side-3">
        <div class="content-wrapper">
          <HomeViewCarparkList></HomeViewCarparkList>
        </div>
      </div>
    </div>
    <div class="right-side" v-show="!isRightSideHide">
      <div class="right-side-wrapper">
        <div class="right-side-1">
          <div class="content-wrapper">
            <HomeViewMessageCenter></HomeViewMessageCenter>
          </div>
        </div>
        <div class="right-side-2">
          <div class="content-wrapper">
            <HomeViewTaskCenterNew></HomeViewTaskCenterNew>
          </div>
        </div>
        <!-- <div class="right-side-3">
          <div class="content-wrapper">
            <HomeViewVideoCenter></HomeViewVideoCenter>
          </div>
        </div> -->
        <div class="right-side-4">
          <div class="content-wrapper">
            <HomeViewFastTrackEntrance></HomeViewFastTrackEntrance>
          </div>
        </div>
      </div>
    </div>
    <div class="left-hide-btn" :class="{working:isLeftSideHide}" @click="handleLeftHide"></div>
    <div class="right-hide-btn" :class="{working:isRightSideHide}" @click="handleRightHide"></div>
    <div class="bottom-hide-btn" :class="{working:isBottomHide}" @click="handleBottomHide"></div>
  </div>
</template>

<script>
import MapView from "./components/MapView";
import HomeViewRealtimeData from "./components/HomeViewRealtimeData";
import HomeViewDeviceList from "./components/HomeViewDeviceList";
import HomeViewCarparkList from "./components/HomeViewCarparkList";
import HomeViewMessageCenter from "./components/HomeViewMessageCenter";
import HomeViewTaskCenterNew from "./components/HomeViewTaskCenterNew";
//import HomeViewVideoCenter from "./components/HomeViewVideoCenter";
import HomeViewFastTrackEntrance from "./components/HomeViewFastTrackEntrance";

export default {
  name: "HomeView2",
  componentName: "HomeView2",
  components: {
    MapView,
    HomeViewRealtimeData,
    HomeViewDeviceList,
    HomeViewCarparkList,
    HomeViewMessageCenter,
    HomeViewTaskCenterNew,
    //HomeViewVideoCenter,
    HomeViewFastTrackEntrance,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      isLeftSideHide: false,
      isRightSideHide: false,
      isBottomHide: false,
    };
  },
  methods: {
    handleLeftHide: function () {
      this.isLeftSideHide = !this.isLeftSideHide;
    },
    handleRightHide: function () {
      this.isRightSideHide = !this.isRightSideHide;
    },
    handleBottomHide:function(){
      this.isBottomHide = !this.isBottomHide;
      
      if(this.isBottomHide)
      {
        // eslint-disable-next-line no-undef
        $(".toggles.combineToggle").hide();
      }else
      {
         // eslint-disable-next-line no-undef
         $(".toggles.combineToggle").show();
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "HomeView2",
};
</script>